import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';

import ModalFull from '@components/modal/ModalFull';
import Colors from '@global/colors';
import { isWeb, isMobileWeb, isNative } from '@global/screens';
import SociollaText from '@components/sociolla/SociollaText';

const ModalRegistration = (props) => {
  return (
    <ModalFull
      testID={props.testID}
      title="Customer Registration"
      show={props.show}
      maxWidth={isWeb && !isMobileWeb ? 500 : '100%'}
      onClose={() => props.onClose()}
      back>
      <View style={styles.customerAdd}>
        <TouchableOpacity
          testID={
            props.testID
              ? `${props.testID}-quick-btn`
              : 'registration-quick-btn'
          }
          activeOpacity={0.6}
          style={styles.itemOption}
          onPress={() => props.onSubmit('quick')}>
          <SociollaText style={styles.itemText}>
            Quick Registration
          </SociollaText>
        </TouchableOpacity>
        <TouchableOpacity
          testID={
            props.testID ? `${props.testID}-full-btn` : 'registration-full-btn'
          }
          activeOpacity={0.6}
          style={styles.itemOption}
          onPress={() => props.onSubmit('full')}>
          <SociollaText style={styles.itemText}>Full Registration</SociollaText>
        </TouchableOpacity>
      </View>
    </ModalFull>
  );
};

const styles = StyleSheet.create({
  customerAdd: {
    width: '100%',
    paddingHorizontal: isWeb ? 25 : 15,
    paddingTop: isWeb ? 25 : 15,
    paddingBottom: isWeb ? 40 : 15,
    flexDirection: isNative ? 'column' : 'row',
    justifyContent: 'center',
  },
  itemOption: {
    padding: 15,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    borderColor: Colors.grey0,
    borderWidth: 1,
    marginHorizontal: isWeb ? 15 : 10,
    marginBottom: isNative ? 20 : 0,
  },
  itemText: {
    fontSize: 14,
  },
});

ModalRegistration.propTypes = {
  testID: PropTypes.string,
  onSubmit: PropTypes.func,
  show: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ModalRegistration;
